<template>
    <div>
        <div class="common-header">
            <div class="common-header-right">
                <div class="common-header-block">
                    <el-select v-model="condition.gameType" placeholder="请选择">
                        <el-option
                        v-for="item in gameTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="common-header-block">
                    <el-input
                            class="common-el-input"
                            placeholder="输入赛事名称查询"
                            v-model="condition.matchName">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <el-button type="primary" @click="searchGame()">搜索</el-button>
                </div>
            </div>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="mtt.mttList"
                    row-key="id"
                    height="100%">
                <el-table-column label="赛事ID" align="center" prop="matchId" width="150"/>
                <el-table-column label="标题" width="150" align="center" prop="matchName"/>
                <el-table-column label="类别" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.gameType == 1">积分赛</span>
                        <span v-else>实物赛</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.matchStatus == 1">未开始</span>
                        <span v-else-if="scope.row.matchStatus == 2">进行中</span>
                        <span v-else-if="scope.row.matchStatus == 0">已结束</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建者" align="center" prop="creatorName"/>
                <el-table-column label="开始日期" min-width="150" align="center" prop="startTime"/>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <el-button @click="checkGame(scope.row.matchId)" type="success">查看</el-button>
                    </template>
                </el-table-column>    
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="mtt.mttListTotal"
                :current-page="currentPage"
                @current-change="searchGame({page:$event})"/>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import utils from '../../../utils/util'
export default {
  // components: {
  //   compClubConfig
  // },
  data() {
    return {
      loading: false,
      centerDialogVisible:false,
      advancedSetting:false,
      date: null,
      searchVal: "",
      configInfo: {},
      currentPage: 1,
      condition: {
        gameType: "0", //状态
        matchStatus: "1", //类型
        matchName: "",
        size:20,
        userId:''
      },
      gameTypes: [
        {
          label: "全部条件",
          value: "0"
        },
        {
          label: "实物赛",
          value: "1"
        },
        {
          label: "积分赛",
          value: "2"
        }
      ]
    };
  },
  computed: {
    ...mapState("mtt", ["mtt", "mttDetail"]),
    userType() {
      return localStorage.getItem("authTypeCode");
    }
  },
  created() {
    this.searchGame({page:1});
    if(this.mttDetail.blindType == 1){
        this.mttDetail.blindTypeLabel = '快速盲注'
    }else{
        this.mttDetail.blindTypeLabel = '普通盲注'
    }
    this.mttDetail.startTime = utils.getUTime(this.mttDetail.startTime)
  },
  methods: {
    ...mapActions("mtt", ["mttDetailApi", "disMttApi", "mttListApi"]),
    // 俱乐部列表
    searchGame(obj = {}) {
      this.loading = true;
      var self = this;
      let params = this.condition;
      params.userId = localStorage.userId;
      Object.assign(params, obj);
      this.currentPage = params.page;
      this.mttListApi(params).then(() => {
        var data = self.mtt.mttList
        for(var i=0;i<data.length;i++){
            data[i].startTime = utils.getUTime(data[i].startTime)
        }
        this.loading = false;
      });
    },
    checkGame(id) {
    //   this.loading = true;
    // //   this.centerDialogVisible = true;
    //   let params = {
    //     matchId: id
    //   };
    //   this.mttDetailApi(params).then(() => {
    //     this.loading = false;
    //     this.$message.success('获取成功');
    //   });
      this.$router.push({name: 'awardDetail', query: {matchId: id}})
    }
  }
};
</script>
<style lang="scss" scoped>
:global(.el-icon-edit-outline) {
  color: $theme-color;
  cursor: pointer;
}
</style>